import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';
import { COLUMNS } from '../constants';

class SummaryTableHeadComponent extends React.PureComponent {
  render () {
    return (

      <thead>
        <tr>
          <th>
            Level of {this.props.categoricalParameter}
          </th>

          <th>
            Measured Variable
          </th>

          {map(COLUMNS, (columnName, columnKey) =>
            <th key={columnKey} className="text-right">
              {columnName}
            </th>
          )}
        </tr>
        <tr />
      </thead>
    );
  }
}

SummaryTableHeadComponent.propTypes = {
  categoricalParameter: PropTypes.string.isRequired
};

export default SummaryTableHeadComponent;
